module.exports = __webpack_public_path__ + "static/media/background_ia.fe4fb96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_page_solutions/chifco_ia/background_ia.png
// module id = 2290
// module chunks = 0